import { render } from "./SettingsPaymentHistoryView.vue?vue&type=template&id=45c8f029"
import script from "./SettingsPaymentHistoryView.vue?vue&type=script&lang=js"
export * from "./SettingsPaymentHistoryView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/SettingsPaymentHistoryView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45c8f029"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45c8f029', __exports__)) {
    api.reload('45c8f029', __exports__)
  }
  
  module.hot.accept("./SettingsPaymentHistoryView.vue?vue&type=template&id=45c8f029", () => {
    api.rerender('45c8f029', render)
  })

}


export default __exports__